const columns = [
  {
    title: "栏目",
    links: [
      { label: "爆料速递", href: "#briefs" },
      { label: "实锤现场", href: "#stories" },
      { label: "翻车汇总", href: "#expose" },
      { label: "社区讨论", href: "#discussion" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "投稿须知", href: "#trust" },
      { label: "常见问题", href: "#faq" },
      { label: "内容准则", href: "#trust" },
      { label: "澄清申请", href: "#subscribe" },
    ],
  },
  {
    title: "快捷入口",
    links: [
      { label: "最新爆料", href: "#briefs" },
      { label: "今日讨论榜", href: "#hot" },
      { label: "热点话题", href: "#discussion" },
      { label: "订阅速递", href: "#subscribe" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full border-t border-secondary-200 bg-secondary-100">
      <div className="px-4 py-10 md:px-8 md:py-12">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                黑料学生
              </span>
            </div>
            <p className="mt-4 max-w-sm text-[13px] leading-relaxed text-foreground-700">
              一个把学生圈爆料、实锤、被扒与翻车瓜集中起来的地方。我们用化名与代号呈现内容，
              标注核实状态，也给当事人留出澄清的空间。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-2">
              {["待核实", "已核实", "已澄清"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-secondary-300/70 bg-secondary-50 px-3 py-1 text-[11px] text-secondary-900"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="text-sm font-semibold text-foreground-900">{column.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-[13px] text-foreground-600 transition-colors hover:text-primary-600 whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-[12px] text-foreground-600">
            © 2026 黑料学生 · 本站内容均为虚构演示，请勿对号入座
          </p>
          <p className="text-[12px] text-foreground-500">
            涉及个人隐私的内容一律不收录 · 欢迎提交澄清材料
          </p>
        </div>
      </div>
    </footer>
  );
}